export { resolveTnegaHome } from '@tnega/home'
